import { render, staticRenderFns } from "./agentBuyCardList.vue?vue&type=template&id=3d87a9d3&scoped=true&"
import script from "./agentBuyCardList.vue?vue&type=script&lang=js&"
export * from "./agentBuyCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87a9d3",
  null
  
)

export default component.exports